import cx from 'clsx';
import React, { useEffect } from 'react';

import DeviceProvider from '@/components/DeviceProvider';
import { LaunchStrategiesProvider } from '@/components/LaunchStrategiesProvider';
import { UserSessionProvider } from '@/components/UserSessionProvider';
import config from '@/config';
import { CallbackMode, DeviceOs } from '@/logic/main/types';
import { GameLaunchStrategies } from '@/types/gameTypes';

import styles from './Layout.module.scss';

interface LayoutPropTypes {
  children?: React.ReactNode;
  deviceType: 'mobile' | 'tablet' | 'desktop';
  deviceOs: DeviceOs;
  launchStrategies: GameLaunchStrategies;
  deviceNative: boolean;
  gameModalOpen?: boolean;
  callbackMode: CallbackMode;
  loggedIn: boolean;
}

const Layout: React.FC<LayoutPropTypes> = ({
  children,
  deviceType,
  deviceOs,
  launchStrategies,
  deviceNative,
  gameModalOpen,
  loggedIn,
}) => {
  const mode = config.staticComponents['Layout']?.mode || 'default';

  useEffect(() => {
    const layoutElement = document.getElementById('layout');
    if (layoutElement) {
      layoutElement.className = cx(styles.layout, {
        [styles.layoutWithNavigation]: mode === 'small',
        [styles.layoutWithFooter]: mode === 'small',
        [styles.overflowHidden]: gameModalOpen,
      });
    }

    const rootContent = document.getElementById('react-root');
    if (rootContent) {
      rootContent.className = cx(styles.rootContent, {
        [styles.contentResponsive]: mode === 'default',
        [styles.contentStatic]: mode !== 'default',
      });
    }

    const pageContent = document.getElementById('page-content');
    if (pageContent) {
      pageContent.className = cx(styles.content);
    }
  }, [mode, gameModalOpen]);

  return (
    <UserSessionProvider loggedIn={loggedIn}>
      <LaunchStrategiesProvider
        launchStrategies={launchStrategies}
        deviceType={deviceType}
        loggedIn={loggedIn}
      >
        <DeviceProvider
          deviceType={deviceType}
          deviceOs={deviceOs}
          deviceNative={deviceNative}
        >
          {children}
        </DeviceProvider>
      </LaunchStrategiesProvider>
    </UserSessionProvider>
  );
};

export default Layout;
